export const DeadlineState = Object.freeze({
	None: 'none',
	Completed: 'completed',
	Deferred: 'deferred',
	SupposedlyCompleted: 'supposedlyCompleted',
	Expired: 'expired',
	Today: 'today',
	Tomorrow: 'tomorrow',
	ThisWeek: 'thisWeek',
	NextWeek: 'nextWeek',
	MoreThanTwoWeeks: 'moreThanTwoWeeks',
});
